import React from 'react';

import { Dialog, Emblem } from '@neptune/shared/venus-ui';

export const CannotAddUsersFromOutsideOfWorkspaceModal = ({
  close,
  inviteToWorkspaceAndProject,
  opened,
  username,
}: {
  close: () => void;
  inviteToWorkspaceAndProject?: () => void;
  opened: boolean;
  username?: string;
}) => {
  return (
    <Dialog
      isOpen={opened}
      title="Can't add user to project"
      primaryButtonLabel="Cancel"
      onPrimaryButtonClick={close}
      secondaryButtonLabel="Invite to both workspace and project"
      onSecondaryButtonClick={inviteToWorkspaceAndProject}
      onClose={close}
    >
      <Dialog.Text>
        The user you&apos;re trying to add isn&apos;t a member of the workspace.
        <br />
        Double-check that the username {username && <Emblem width="auto" text={username} />} is
        correct, or invite the user to the workspace.
      </Dialog.Text>
    </Dialog>
  );
};
